module.exports = __webpack_public_path__ + "img/next.21341dd3.svg";